import config from '/front/config';

export default async function getMenus() {
    const resp = await config.api.menu.get();
    return 'error' in resp ? [] : resp;
}
